var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<tags-input ng-model=\"model[options.key]\" on-tag-removed=\"tagRemoved()\" ng-required=\"to.required\"></tags-input>";
var id1="bsstags.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;